function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rename",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9,2.3 L14.9,3.5 L20.8,3.5 C21.4,3.5 21.8,3.9 21.8,4.5 L21.8,17.4 C21.8,18 21.4,18.4 20.8,18.4 L2.2,18.4 C1.6,18.4 1.2,18 1.2,17.4 L1.2,4.4 C1.2,3.8 1.6,3.4 2.2,3.4 L8.1,3.4 L8.1,2.3 L1,2.3 C0.4,2.3 0,2.7 0,3.3 L0,18.5 C0,19.1 0.4,19.5 1,19.5 L22,19.5 C22.6,19.5 23,19.1 23,18.5 L23,3.3 C23,2.7 22.6,2.3 22,2.3 L14.9,2.3 Z M13.8,1.1 L13.8,0 L9.2,0 L9.2,1.1 L9.2,3.5 C9.2,4.1 9.6,4.5 10.2,4.5 L12.8,4.5 C13.4,4.5 13.8,4.1 13.8,3.5 L13.8,1.1 L13.8,1.1 Z M4.5,16.1 L10.4,16.1 C11,16.1 11.5,15.5 11.4,14.9 C10.9,11.5 8,11.5 8,11.5 L8,12.6 L6.9,12.6 L6.9,11.5 C6.9,11.5 4.1,11.5 3.5,14.9 C3.4,15.5 3.9,16.1 4.5,16.1 Z M13.8,8.1 L19.6,8.1 L19.6,9.2 L13.8,9.2 L13.8,8.1 Z M13.8,10.4 L19.6,10.4 L19.6,11.5 L13.8,11.5 L13.8,10.4 Z M13.8,12.6 L19.6,12.6 L19.6,13.7 L13.8,13.7 L13.8,12.6 Z M7.5,10.8 C8.71502645,10.8 9.7,9.81502645 9.7,8.6 C9.7,7.38497355 8.71502645,6.4 7.5,6.4 C6.28497355,6.4 5.3,7.38497355 5.3,8.6 C5.3,9.81502645 6.28497355,10.8 7.5,10.8 Z",
  id: "staff-management-svg-icon"
})));

function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User Management") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.6a283ebd.svg";
export { ForwardRef as ReactComponent };